module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-menu__item ")
    ; __append(escapeFn( widget.color ? widget.color : '' ))
    ; __append("\" on-click=\"onClick\">\n	<div class=\"tile-icon-64 ")
    ; __append(escapeFn( widget.icon ? widget.icon : '' ))
    ; __append(" icon-64\"></div>\n	<div class=\"gl-menu__item_title\">\n		<span>")
    ; __append(escapeFn( widget.title ))
    ; __append("</span>\n	</div>\n</div>")
  }
  return __output.join("");

}